// cvData.js
export const cvData = {
  personal: {
    name: "Charles David Mupende",
    location: "Stuttgart, Germany",
    birthdate: "15.08.1995",
    birthplace: "Kinshasa, DR. Kongo",
    email: "charlesdavid@mupende.com",
    phone: "+491794157744",
    linkedin: {
      url: "https://www.linkedin.com/in/charlesmupende/",
      display: "linkedin.com/in/charlesmupende",
    },
    image: "https://cdn.mupende.com/raw/MXHXBi.jpeg",
  },

  summary:
    "Product engineer with a background in product management, business analysis, and software development. I design and build digital products that feel simple to use yet deliver measurable business value. My focus lies in bridging technical depth with user understanding to create solutions that truly meet people’s needs.",

  experience: [
    {
      title: "Founder and Product Engineer",
      company: "[d]atacook",
      period: "Jan 2025 - Present",
      image: "https://cdn.mupende.com/raw/UwUgHu.png",
      description:
        "Designing and building software solutions focused on machine learning and intelligent systems. Contributing to product strategy and user experience design to deliver meaningful value to users. Providing consulting services and process automation solutions to optimize business operations.",
    },
    {
      title: "Product Manager",
      company: "Daimler Truck Financial Services GmbH",
      period: "Jul 2025 - Present",
      location: "Leinfelden-Echterdingen, Baden-Württemberg, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/C4D0BAQEsJbu2MyCs8g/company-logo_200_200/company-logo_200_200/0/1643214524407/daimler_truck_financial_services_logo?e=1762992000&v=beta&t=-nP7hc5wURLMr7GvrpzQg4fE01zQ-uYG6Tw_xFVMlfY",
      description:
        "Product Manager for the payment orchestration platform Daimler Truck Pay, building a best-in-class payment platform that simplifies complexities of payment solutions in the B2B truck industry. Translating business needs into actionable product plans while exploring new technical possibilities and market trends.",
      achievements: [
        "Developed product vision for Daimler Truck Pay platform serving B2B truck industry",
        "Aligned stakeholder requirements into clear, actionable product roadmap",
        "Explored emerging payment technologies to maintain competitive advantage",
      ],
    },
    {
      title: "Project Manager",
      company: "Daimler Truck Financial Services GmbH",
      period: "Oct 2022 - Aug 2025",
      location: "Leinfelden-Echterdingen, Baden-Württemberg, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/C4D0BAQEsJbu2MyCs8g/company-logo_200_200/company-logo_200_200/0/1643214524407/daimler_truck_financial_services_logo?e=1762992000&v=beta&t=-nP7hc5wURLMr7GvrpzQg4fE01zQ-uYG6Tw_xFVMlfY",
      description:
        "Responsible for successful rollout of Daimler Truck Pay platform across multiple international markets. Managed deployments in B2B after-sales online stores across Australia, South Africa, USA, Japan, and Mexico, acting as bridge between stakeholders and IT development teams.",
      achievements: [
        "Successfully deployed payment platform across 5+ international markets",
        "Led renewal of USA payment landscape, replacing legacy IT solutions",
        "Coordinated cross-functional teams ensuring on-time delivery of market requirements",
      ],
    },
    {
      title: "Master Thesis Student",
      company: "Porsche Engineering Group GmbH",
      period: "Nov 2021 - May 2022",
      location: "Bietigheim-Bissingen, Baden-Württemberg, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/C4E0BAQFYNatGjMPGvQ/company-logo_200_200/company-logo_200_200/0/1677566368161/porsche_engineering_logo?e=1762992000&v=beta&t=qyib1Li8msz22Yvs6oYZLWoIsoQQ_CHr6sMnZYwRQ10",
      description:
        "Conducted research and development work as part of master's thesis project in automotive engineering domain.",
      achievements: [
        "Completed comprehensive research project in automotive technology",
        "Collaborated with engineering teams on innovative solutions",
        "Delivered thesis contributing to product development insights",
      ],
    },
    {
      title: "Project Manager",
      company: "Noor Vision GmbH",
      period: "Nov 2019 - Jul 2021",
      location: "Düsseldorf, Nordrhein-Westfalen, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/D4E0BAQG7b0C-ZbmyVw/company-logo_200_200/company-logo_200_200/0/1718626766772/noor_vision_management_consulting_logo?e=1762992000&v=beta&t=gp5UhW4JLzJnY8-dS6cgWxHPP7wW4AaY3ThAcz0ao8g",
      description:
        "Associate project manager coordinating various project teams and managing development specifications in LES-WM and SAP Fiori. Responsible for project planning, team coordination, and customer communication.",
      achievements: [
        "Coordinated cross-functional teams of approximately 8 team members",
        "Created and maintained comprehensive project plans and open points lists",
        "Delivered LES-WM and SAP Fiori customizations meeting customer requirements",
      ],
    },
    {
      title: "Intern Transformation Management",
      company: "voestalpine",
      period: "May 2019 - Oct 2019",
      location: "Dortmund, Nordrhein-Westfalen, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/C4E0BAQHkN-17Ov4Kmg/company-logo_200_200/company-logo_200_200/0/1631307368552?e=1762992000&v=beta&t=9ywifZnnJgmh4yYcY1H8pU8iIjP6_CvS70Oi4xxusUA",
      description:
        "Provided on-site support during SAP rollout project, specializing in SAP MM (Material Management) module. Supported CutOver and GoLive phases, conducted user training, and provided hypercare support.",
      achievements: [
        "Successfully supported SAP MM module implementation during critical GoLive phase",
        "Delivered user training programs improving system adoption rates",
        "Created reports and documentation for material management processes",
      ],
    },
    {
      title: "Student Research Assistant",
      company: "Albert-Ludwigs-Universität Freiburg",
      period: "Apr 2018 - Sep 2018",
      location: "Freiburg im Breisgau, Baden-Württemberg, Deutschland",
      image:
        "https://media.licdn.com/dms/image/v2/C4E0BAQGWRw584ibV7Q/company-logo_200_200/company-logo_200_200/0/1677671036177/albert_ludwigs_universitaet_freiburg_logo?e=1762992000&v=beta&t=UBrVlqGTPPCLqQQ6Cmnda3iceG091GY8QZCF0wFNmoY",
      description:
        "Supported IT infrastructure maintenance, integrated new software solutions, and managed database administration. Worked on cloud solution implementations and system integrations.",
      achievements: [
        "Maintained and optimized existing IT infrastructure systems",
        "Successfully integrated new software and cloud solutions",
        "Performed database administration ensuring system reliability",
      ],
    },
  ],

  education: [
    {
      degree: "Master of Science, Business Informatics",
      institution: "Universität Trier",
      period: "2019 - 2023",
      image:
        "https://media.licdn.com/dms/image/v2/D4E0BAQH5TcpLmaAfRw/company-logo_200_200/company-logo_200_200/0/1686725281733/trieruni_logo?e=1762992000&v=beta&t=o6OZThlQTOWSHr6pXaIImLikQo3wTq6DeObC8wK3Gls",
      description:
        "Advanced studies in business informatics with focus on data science, machine learning, AI, reinforcement learning, optimization, and business intelligence. Graduated with distinction (Grade: 1.7).",
      achievements: [
        "Graduated with excellent grade of 1.7",
        "Master's Thesis: 'A Hybrid Approach for Dynamic Multi-Objective Optimization: Combining the Knowledge Guided Bayesian Classification Algorithm with Reinforcement Learning' (Grade: 1.0)",
        "Specialized in Machine Learning, Reinforcement Learning, and AI optimization algorithms",
      ],
    },
    {
      degree: "Bachelor of Science, Economics",
      institution: "Albert-Ludwigs-Universität Freiburg",
      period: "2015 - 2019",
      image:
        "https://media.licdn.com/dms/image/v2/C4E0BAQGWRw584ibV7Q/company-logo_200_200/company-logo_200_200/0/1677671036177/albert_ludwigs_universitaet_freiburg_logo?e=1762992000&v=beta&t=UBrVlqGTPPCLqQQ6Cmnda3iceG091GY8QZCF0wFNmoY",
      description:
        "Comprehensive economics program with focus on business intelligence, data analysis, optimization and simulation. Strong foundation in quantitative analysis and economic modeling.",
      achievements: [
        "Graduated with grade of 2.2",
        "Bachelor's Thesis: 'Spatio-Temporal Modeling: Analyzing Street Crime in Detroit' (Grade: 1.0)",
        "Developed expertise in business intelligence and data analysis methodologies",
      ],
    },
  ],

  certificates: [
    {
      name: "Design Thinking for Artificial Intelligence (DT4AI)",
      institution: "University of St. Gallen",
      period: "Feb 2023 - May 2023",
      image:
        "https://media.licdn.com/dms/image/v2/C560BAQFwnhW-GPfiYw/company-logo_200_200/company-logo_200_200/0/1630655380576/university_of_st_gallen_logo?e=1762992000&v=beta&t=g0aEwoho3mu0OI-EOdUDu9Q5lmlWb6EXbSw4RKGMknU",
      description:
        "Corporate partner certification program focusing on applying Design Thinking methods to AI-driven business problems. Collaborated with University of St. Gallen as industry-research partnership representative from Daimler Truck Financial Services GmbH.",
      achievements: [
        "Led cross-functional team of master students as active corporate liaison",
        "Created AI-driven solution to innovate data-driven business models",
        "Acquired fundamental knowledge of Design Thinking and AI based on state-of-the-art research",
        "Promoted corporate innovation through industry-research partnership",
      ],
    },
  ],

  publications: [
    {
      title:
        "A Hybrid Approach for Dynamic Multi-Objective Optimization: Combining the Knowledge Guided Bayesian Classification Algorithm with Reinforcement Learning",
      type: "Master's Thesis",
      year: "2023",
      url: "https://thesis.mupende.com",
      image:
        "https://media.licdn.com/dms/image/v2/D4E0BAQH5TcpLmaAfRw/company-logo_200_200/company-logo_200_200/0/1686725281733/trieruni_logo?e=1762992000&v=beta&t=o6OZThlQTOWSHr6pXaIImLikQo3wTq6DeObC8wK3Gls",
      description:
        "Developed RL-KGB-DMOEA, a novel algorithm that combines reinforcement learning with Bayesian classification to solve dynamic multi-objective optimization problems. The approach significantly reduces computational time while maintaining performance by intelligently selecting between prediction methods.",
      keywords: [
        "Machine Learning",
        "Optimization",
        "Reinforcement Learning",
        "Bayesian Classification",
      ],
    },
  ],

  languages: [
    {
      name: "German",
      level: "Native",
      flag: "https://flagicons.lipis.dev/flags/4x3/de.svg",
    },
    {
      name: "English",
      level: "Fluent",
      flag: "https://flagicons.lipis.dev/flags/4x3/us.svg",
    },
    {
      name: "French",
      level: "Fluent",
      flag: "https://flagicons.lipis.dev/flags/4x3/fr.svg",
    },
  ],

  skills: {
    "Frontend Development": [
      "React",
      "JavaScript",
      "TypeScript",
      "CSS",
      "HTML",
    ],
    "Backend Development": ["Node.js", "Python", "PostgreSQL"],
    "AI & Machine Learning": [
      "OpenAI API",
      "Vector Databases",
      "Computer Vision",
    ],
    "Design & UX": [
      "Product Design",
      "User Experience",
      "Prototyping",
      "Design Systems",
    ],
  },

  achievements: [
    {
      title: "30+ Software Products",
      description:
        "Successfully redesigned or launched software products, improving user experience and business outcomes.",
    },
    {
      title: "12+ Years Experience",
      description:
        "Delivering top-notch UX and design services across various industries and project scales.",
    },
    {
      title: "Operational Efficiency",
      description:
        "Significantly improved operational efficiency at KeLo through cohesive UX design processes.",
    },
  ],
};
